import type { ReactNode } from 'react';
import { PanelPageState } from '@/presentation/components/common/PanelPageState';

interface EmptyStateProps {
  title: string;
  message: string;
  action?: ReactNode;
}

/** Empty state compacto — delega en PanelPageState. */
export function EmptyState({ title, message, action }: EmptyStateProps) {
  return (
    <PanelPageState
      variant="empty"
      layout="inline"
      title={title}
      message={message}
      action={action}
    />
  );
}
